// Estimated eggs are shown as a range around the model's single estimate. Same band as
// the embedded calculator (rhea-egg-calc-embed, src/utils.tsx).
export const eggsRange = (eggs: number): [number, number] => {
  const from = Math.max(0, Math.min(eggs - 2, Math.floor(0.8 * eggs)));
  const to = Math.max(eggs + 2, Math.ceil(1.2 * eggs));

  return [from, to];
};

// Live-birth figures are rounded to the nearest 5% so they read as group-level
// illustrations rather than a precise individual prognosis.
export const approxPercent = (percent: number): string =>
  `~${Math.round(percent / 5) * 5}%`;
